import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
} from '@mui/icons-material';
import type { PatternTestResponse } from '../../../types/backend';

interface PatternTestResultProps {
  result: PatternTestResponse | null;
}

const PatternTestResult: React.FC<PatternTestResultProps> = ({ result }) => {
  if (!result) return null;

  return (
    <Chip
      icon={result.matches ? <CheckCircleIcon /> : <ErrorIcon />}
      label={result.matches ? 'Pattern matches' : 'No match'}
      color={result.matches ? 'success' : 'error'}
      variant="outlined"
      size="small"
    />
  );
};

export default PatternTestResult;
